'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/9/12.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';

var MyCommissionsComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MyCommissionsComponent, _Component);

  function MyCommissionsComponent() {
    (0, _classCallCheck3.default)(this, MyCommissionsComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MyCommissionsComponent).apply(this, arguments));
  }

  (0, _createClass3.default)(MyCommissionsComponent, [{
    key: 'itemClick',
    value: function itemClick(filterStr) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick) {
        onItemClick(filterStr);
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var input = this.refs.searchInput.value;
      var onSearch = this.props.onSearch;

      if (onSearch) {
        onSearch(input);
      }
    }
  }, {
    key: 'handChange',
    value: function handChange(event) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick && event) {
        onItemClick(event.target.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./MyCommissionsComponent.scss');
      var commissions = this.props.commissions;

      var commissionsShow = commissions.map(function (commission, index) {
        return _react2.default.createElement(
          'tr',
          { key: commission.id + index, className: styles.comTr, style: { background: index % 2 === 0 ? '#f9f8f8' : '' } },
          _react2.default.createElement(
            'td',
            null,
            index + 1
          ),
          _react2.default.createElement(
            'td',
            null,
            commission.name
          ),
          _react2.default.createElement(
            'td',
            null,
            commission.product
          ),
          _react2.default.createElement(
            'td',
            null,
            commission.shop
          ),
          _react2.default.createElement(
            'td',
            null,
            commission.time
          ),
          _react2.default.createElement(
            'td',
            null,
            commission.buymoney
          ),
          _react2.default.createElement(
            'td',
            null,
            commission.commissionRate
          ),
          _react2.default.createElement(
            'td',
            null,
            commission.commissions
          )
        );
      });
      /*
       <td><Link to={'/commissionsdetails/' + commission.id}
       className={styles.bttn}>查询</Link>
       </td>
      const myCommissionsSummarizeShow = (
        <div>
          <div className={styles.sqtxt1}>截止日期{myCommissionsSummarize[0].deadlines}</div>
          <div className={styles.sqtxt2}>
            佣金总额：¥<span>{myCommissionsSummarize[0].totalCommissions}</span><br/>
            可提现总额：¥<span>{myCommissionsSummarize[0].withdrawCommissions}</span>
          </div>
        </div>
      ); */
      return _react2.default.createElement(
        'tbody',
        null,
        commissionsShow
      );
    }
  }]);
  return MyCommissionsComponent;
}(_react.Component), _class.propTypes = {
  commissions: _react.PropTypes.array.isRequired,
  // myCommissionsSummarize: PropTypes.array.isRequired,
  onSearch: _react.PropTypes.func,
  onItemClick: _react.PropTypes.func
}, _temp);
exports.default = MyCommissionsComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MyCommissionsComponent/MyCommissionsComponent.js
 ** module id = 1375
 ** module chunks = 0
 **/